export const DEFAULT_LICENSES_MODAL_STATE = {
  toSuspendAutorenewal: [],
  toEnableAutorenewal: [],
  licensesSubscriptionCost: 0,
  licensesSubscriptionFullPeriodCost: 0,
  isViewMode: false,
};

export const IS_NEED_SHOW_LICENSES_MODAL = 'IS_NEED_SHOW_LICENSES_MODAL';
export const IS_NEED_REDIRECT_TO_SOURCE_FROM_KEY = 'IS_NEED_REDIRECT_TO_SOURCE_FROM';
export const INACTIVE_STATUS_VALUE = 'INACTIVE_STATUS';
export const CURRENT_POINT_KEY = 'CURRENT_POINT';
export const PERSISTED_LICENSES_KEY = 'PERSISTED_LICENSES_KEY';
export const ONBOARDING_FLOW = 'ONBOARDING_FLOW';
